<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>产品</el-breadcrumb-item>
      <el-breadcrumb-item>产品库</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="关键字" prop="query">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="名称、件号、机型"
            ></el-input>
          </el-form-item>
          <el-form-item label="类别" prop="item_category_id">
            <el-select
              v-model="filter.item_category_id"
              filterable
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in cates"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestItems()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="零件" name="Item"></el-tab-pane>
        <el-tab-pane label="设备" name="Device"></el-tab-pane>
      </el-tabs>
      <component v-bind:is="currentTabComponent" :filter="params"></component>
    </div>
  </div>
</template>
<script>
import Item from '@/views/product/item/_item'
import Device from '@/views/product/item/_device'
import { clone } from '@/util'

import { itemCategoryList } from '@/service/getData'

export default {
  components: {
    Item,
    Device,
  },
  data() {
    return {
      filter: {
        query: '',
        item_category_id: '',
      },
      params: {
        query: '',
        item_category_id: '',
        size: 20,
        page: 1,
        category: 1,
      },
      cates: [],
      currentTabComponent: Item,
      activeName: 'Item',
    }
  },
  created() {
    this.getItemCategoryList()
  },
  methods: {
    handleTabClick(tab, event) {
      this.currentTabComponent = tab.name
      this.reset()
    },
    async requestItems() {
      let data = this.params
      data.category = this.activeName == 'Item' ? 1 : 2
      data.query = this.filter.query
      data.item_category_id = this.filter.item_category_id
      this.params = data
    },
    reset() {
      this.params.page = 1
      this.$refs['filterForm'].resetFields()
      this.requestItems()
      this.getItemCategoryList()
    },
    async getItemCategoryList() {
      let category = this.activeName == 'Item' ? 1 : 2
      let res = await itemCategoryList({
        page: 0,
        size: 1000,
        category: category,
      })
      if (res.code == 0) {
        this.cates = res.data.list
      }
    },
  },
}
</script>